import React, { useLayoutEffect, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import LoadGeneralContext from 'context/LoadGeneralContext';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import AddBtn from 'components/AddBtn';
import { BlogProps } from 'types/BlogProps';
import { getBlogs, saveOrderReq } from './reqs';
import ListBlogs from 'components/ListBlogs';
import FormBlog from 'components/FormBlog';
import PreviewBlog from 'components/PreviewBlog';

export default function ScreensTrainings() {
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { i18n }: UseTranslationProps = useTranslation();

	const [blogs, setBlogs] = useState<BlogProps[]>([]);
	const [blogToEditOrSee, setBlogToEditOrSee] = useState<BlogProps | null>(
		null
	);
	const [isOpenForm, setIsOpenForm] = useState(false);
	const [viewPreview, setViewPreview] = useState(false);
	const [isLoad, setIsLoad] = useState(false);

	function resetForm() {
		setBlogToEditOrSee(null);
		setViewPreview(false);
		setIsOpenForm(false);
	}

	async function saveOrderList() {
		if (blogs.length === 0) return;

		setIsOpenLoad(true);
		setMessage('Salvando ordem da lista...');

		await saveOrderReq(blogs, handleNotify);

		setIsOpenLoad(false);
	}

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({ ...value, title: 'Blog' }));
	}, [i18n?.language]);

	//busca pelos treinamentos
	useEffect(() => {
		(async () => {
			setBlogs(await getBlogs(setIsLoad, handleNotify));
		})();
	}, []);

	return (
		<S.container>
			<AddBtn
				text="Adicionar novo item"
				anyFunction={() => {
					setIsOpenForm(true);
				}}
			/>

			<ListBlogs
				blogs={blogs}
				setBlogs={setBlogs}
				setBlogToEditOrSee={setBlogToEditOrSee}
				setIsOpenForm={setIsOpenForm}
				setViewPreview={setViewPreview}
				isLoad={isLoad}
			/>

			<S.saveOrder $canSave={blogs.length > 0}>
				<button
					onClick={async () => {
						await saveOrderList();
					}}
				>
					Salvar ordenação
				</button>
			</S.saveOrder>

			{isOpenForm && (
				<FormBlog
					resetFunction={resetForm}
					isOpenForm={isOpenForm}
					setIsOpenForm={setIsOpenForm}
					blogToEdit={blogToEditOrSee}
					setBlogs={setBlogs}
					setIsLoad={setIsLoad}
					blogs={blogs}
				/>
			)}

			{viewPreview && (
				<PreviewBlog
					resetFunction={resetForm}
					isOpenForm={viewPreview}
					setIsOpenForm={setViewPreview}
					blogToView={blogToEditOrSee}
				/>
			)}
		</S.container>
	);
}
